import {Totals} from './Totals';
export default Totals;